export enum AzureWebPubSubEvents {
  Connected = 'connected',
  Disconnected = 'disconnected',
  GroupMessage = 'group-message',
  ServerMessage = 'server-message',
}

export enum EventTypes {
  Connect = 'connect',
  Heartbeat = 'heartbeat',
  JoinChannel = 'joinChannel',
  LeaveChannel = 'leaveChannel',
}

export const AUDIO_FILES = {
  ALERT: '/assets/notifications/alarm.wav',
} as const;

export const AZURE_PUB_SUB_API_ENDPOINTS = {
  CLIENT_REGISTRATIONS: '/api/transport/azure/registration',
  CLIENT_CONNECTIONS: '/api/transport/azure/connection',
  CLIENT_SUBSCRIPTIONS: 'api/transport/azure/subscription',
};

export const CONNECTION_CONFIG = {
  HEARTBEAT_INTERVAL: 60000,
  MAX_RETRY_COUNT: 3,
  INITIAL_RETRY_DELAY: 3000,
};
